import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from "../utils/common";
import store from "../store";

const ProtectedRoute = ({ element: Element, requiresPayment = false, ...rest }) => {
  // Check authentication
  const isAuth = isAuthenticated();
  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  // Check payment status for premium features
  if (requiresPayment) {
    const isPaid = store?.restaurantInfo?.description !== "unpaid";
    if (!isPaid) {
      // Redirect to dashboard with a message or show payment warning
      return <Navigate to="/dashboard" />;
    }
  }

  return <Element {...rest} />;
};

export default ProtectedRoute;